export type DomainStatus = 'no_configurado' | 'pendiente_dns' | 'verificado' | 'activo' | 'error';

export interface DnsRecord {
  type: 'CNAME' | 'A' | 'TXT';
  host: string;
  value: string;
  ttl: number;
}

export interface VerificationEntry {
  id: number;
  timestamp: string;
  result: 'success' | 'failure';
  message: string;
}

export interface RadioDomainData {
  radioId: number;
  radioName: string;
  frequency: string;
  logoUrl: string;
  plan: 'free' | 'pro' | 'premium';
  hasDomainFeature: boolean;
  domainStatus: DomainStatus;
  domain: string | null;
  dnsInstructions: DnsRecord[];
  verifiedAt: string | null;
  activatedAt: string | null;
  lastCheckedAt: string | null;
  errorMessage: string | null;
  verificationHistory: VerificationEntry[];
}

export const defaultAdminDomainData: RadioDomainData = {
  radioId: 1,
  radioName: 'Radio Nueva Actitud',
  frequency: '94.70 RFW',
  logoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20circular%20design%2C%20warm%20golden%20amber%20colors%2C%20sound%20wave%20symbol%2C%20clean%20corporate%20style%2C%20abstract%20geometric%20mark%2C%20high%20contrast%20professional%20brand%20identity&width=120&height=120&seq=sa-radio-logo-1&orientation=squarish',
  plan: 'pro',
  hasDomainFeature: false,
  domainStatus: 'no_configurado',
  domain: null,
  dnsInstructions: [],
  verifiedAt: null,
  activatedAt: null,
  lastCheckedAt: null,
  errorMessage: null,
  verificationHistory: [],
};

export const radioDomainDataList: RadioDomainData[] = [
  {
    radioId: 1,
    radioName: 'Radio Nueva Actitud',
    frequency: '94.70 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20circular%20design%2C%20warm%20golden%20amber%20colors%2C%20sound%20wave%20symbol%2C%20clean%20corporate%20style%2C%20abstract%20geometric%20mark%2C%20high%20contrast%20professional%20brand%20identity&width=120&height=120&seq=sa-radio-logo-1&orientation=squarish',
    plan: 'pro',
    hasDomainFeature: false,
    domainStatus: 'no_configurado',
    domain: null,
    dnsInstructions: [],
    verifiedAt: null,
    activatedAt: null,
    lastCheckedAt: null,
    errorMessage: null,
    verificationHistory: [],
  },
  {
    radioId: 2,
    radioName: 'Radio Ritmo Latino',
    frequency: '101.30 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=Latin%20radio%20station%20logo%20design%2C%20vibrant%20warm%20colors%20red%20orange%20coral%2C%20tropical%20music%20theme%2C%20circular%20emblem%2C%20modern%20flat%20design%2C%20clean%20background%20professional%20brand%20mark&width=120&height=120&seq=sa-radio-logo-2&orientation=squarish',
    plan: 'free',
    hasDomainFeature: false,
    domainStatus: 'no_configurado',
    domain: null,
    dnsInstructions: [],
    verifiedAt: null,
    activatedAt: null,
    lastCheckedAt: null,
    errorMessage: null,
    verificationHistory: [],
  },
  {
    radioId: 3,
    radioName: 'Radio Éxitos TV',
    frequency: '94.70 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20station%20logo%2C%20bold%20modern%20design%2C%20metallic%20silver%20and%20crimson%20red%20accents%2C%20broadcast%20tower%20icon%2C%20sleek%20corporate%20identity%2C%20high%20contrast%20minimalist%20style&width=120&height=120&seq=sa-radio-logo-3&orientation=squarish',
    plan: 'premium',
    hasDomainFeature: true,
    domainStatus: 'activo',
    domain: 'exitostv.mx',
    dnsInstructions: [
      { type: 'CNAME', host: 'www', value: 'radiofrecuenciaweb.com', ttl: 3600 },
      { type: 'A', host: '@', value: '76.76.21.21', ttl: 3600 },
      { type: 'TXT', host: '@', value: 'rfw-verify=a8f3c9d2e1b4', ttl: 300 },
    ],
    verifiedAt: '2025-01-10T09:00:00',
    activatedAt: '2025-01-10T09:30:00',
    lastCheckedAt: '2026-06-10T06:00:00',
    errorMessage: null,
    verificationHistory: [
      { id: 1, timestamp: '2025-01-09T14:30:00', result: 'failure', message: 'Registro CNAME no encontrado. Asegurate de haber creado www → radiofrecuenciaweb.com' },
      { id: 2, timestamp: '2025-01-10T08:00:00', result: 'failure', message: 'CNAME detectado pero TXT de verificación no encontrado' },
      { id: 3, timestamp: '2025-01-10T09:00:00', result: 'success', message: 'Todos los registros DNS verificados correctamente. Dominio listo para activar.' },
    ],
  },
  {
    radioId: 5,
    radioName: 'Radio Pirata FM',
    frequency: '99.90 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=Rebel%20radio%20station%20logo%2C%20dark%20skull%20and%20crossbones%20radio%20theme%2C%20edgy%20underground%20design%2C%20black%20and%20crimson%20colors%2C%20grunge%20aesthetic%20brand%20identity&width=120&height=120&seq=sa-radio-logo-5&orientation=squarish',
    plan: 'free',
    hasDomainFeature: false,
    domainStatus: 'no_configurado',
    domain: null,
    dnsInstructions: [],
    verifiedAt: null,
    activatedAt: null,
    lastCheckedAt: null,
    errorMessage: null,
    verificationHistory: [],
  },
  {
    radioId: 7,
    radioName: 'Radio Stereo Visión',
    frequency: '96.10 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=Urban%20radio%20station%20logo%2C%20graffiti%20street%20art%20style%2C%20vibrant%20purple%20and%20lime%20green%20colors%2C%20city%20skyline%20element%2C%20modern%20hip%20hop%20culture%20brand%20identity&width=120&height=120&seq=sa-radio-logo-7&orientation=squarish',
    plan: 'premium',
    hasDomainFeature: true,
    domainStatus: 'pendiente_dns',
    domain: 'stereovision.co',
    dnsInstructions: [
      { type: 'CNAME', host: 'www', value: 'radiofrecuenciaweb.com', ttl: 3600 },
      { type: 'TXT', host: '@', value: 'rfw-verify=k9m2x7p4r1s8', ttl: 300 },
    ],
    verifiedAt: null,
    activatedAt: null,
    lastCheckedAt: '2026-06-10T12:00:00',
    errorMessage: null,
    verificationHistory: [
      { id: 1, timestamp: '2026-06-10T12:00:00', result: 'failure', message: 'Registro CNAME www no encontrado. Se requiere apuntar www.stereovision.co → radiofrecuenciaweb.com' },
    ],
  },
  {
    radioId: 8,
    radioName: 'Radio Clásica FM',
    frequency: '88.90 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20radio%20station%20logo%2C%20sophisticated%20gold%20and%20ivory%20palette%2C%20violin%20and%20orchestra%20elements%2C%20refined%20circular%20emblem%2C%20luxury%20brand%20identity%20for%20cultured%20audience&width=120&height=120&seq=sa-radio-logo-8&orientation=squarish',
    plan: 'premium',
    hasDomainFeature: true,
    domainStatus: 'verificado',
    domain: 'clasicafm.cl',
    dnsInstructions: [
      { type: 'CNAME', host: 'www', value: 'radiofrecuenciaweb.com', ttl: 3600 },
      { type: 'A', host: '@', value: '76.76.21.21', ttl: 3600 },
      { type: 'TXT', host: '@', value: 'rfw-verify=v3n7w1c6j0q4', ttl: 300 },
    ],
    verifiedAt: '2026-05-20T15:30:00',
    activatedAt: null,
    lastCheckedAt: '2026-06-09T18:00:00',
    errorMessage: null,
    verificationHistory: [
      { id: 1, timestamp: '2026-05-19T10:00:00', result: 'failure', message: 'CNAME y A encontrados, TXT de verificación ausente' },
      { id: 2, timestamp: '2026-05-20T15:30:00', result: 'success', message: 'Todos los registros DNS verificados correctamente.' },
    ],
  },
  {
    radioId: 10,
    radioName: 'Radio Élite Digital',
    frequency: '107.50 RFW',
    logoUrl: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%2C%20professional%20serious%20design%2C%20navy%20blue%20and%20silver%20metallic%2C%20globe%20and%20microphone%20elements%2C%20authoritative%20corporate%20brand%20identity%20for%20journalism&width=120&height=120&seq=sa-radio-logo-10&orientation=squarish',
    plan: 'premium',
    hasDomainFeature: true,
    domainStatus: 'activo',
    domain: 'elitedigital.es',
    dnsInstructions: [
      { type: 'CNAME', host: 'www', value: 'radiofrecuenciaweb.com', ttl: 3600 },
      { type: 'A', host: '@', value: '76.76.21.21', ttl: 3600 },
      { type: 'TXT', host: '@', value: 'rfw-verify=g7t4n0b5x2d1', ttl: 300 },
    ],
    verifiedAt: '2025-02-15T11:00:00',
    activatedAt: '2025-02-15T11:45:00',
    lastCheckedAt: '2026-06-11T03:00:00',
    errorMessage: null,
    verificationHistory: [
      { id: 1, timestamp: '2025-02-15T10:00:00', result: 'failure', message: 'Registros DNS no propagados aún. Intenta en unos minutos.' },
      { id: 2, timestamp: '2025-02-15T11:00:00', result: 'success', message: 'Todos los registros DNS verificados. Dominio listo para activar.' },
    ],
  },
];

export function getRadioDomainById(radioId: number): RadioDomainData | undefined {
  return radioDomainDataList.find((r) => r.radioId === radioId);
}